import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const blockEl = 'ui__tab';

const Tab = ({ 
  className = null, 
  isActive = false, 
  label, 
  onClick = () => {} 
}) => (
  <div className={classNames(blockEl, className, {
    [`${blockEl}--is-active`]: isActive
  })}
  >
    <button
      type="button"
      className="btn p-0"
      onClick={onClick}
    >{label}
    </button>
  </div>
);

Tab.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};

Tab.displayName = 'Tab';

export default Tab;
